import Vue from 'vue'
import store from './store'
import App from './App.vue'
import axios from 'axios';
import moment from 'moment';
import TitleMixin from '@/mixins/TitleMixin'

axios.defaults.withCredentials = true
axios.defaults.baseURL = 'https://api.thor.benevolat.org'

Vue.config.productionTip = false

Vue.filter('frenchDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY à HH:mm');
  }
});

Vue.mixin(TitleMixin)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
